import * as Consts from './Consts';
const TABS_ITEMS_PADDING = 210;
import * as Colors from 'material-ui/styles/colors';

export default {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  buttonsSection: {
    height: Consts.BUTTONS_SECTION_HEIGHT,
    backgroundColor: Colors.grey50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    zIndex: 2,
  },
  imagesPreviewContainer: {
    display: 'flex',
    paddingTop: 20,
    height: 220,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  previewAndProps: {
    backgroundColor: 'white',
    height: Consts.PREVIEW_AND_PROPS_HEIGHT,
    maxHeight: Consts.PREVIEW_AND_PROPS_HEIGHT,
    padding: Consts.PREVIEW_AND_PROPS_PADDING,
    overflowY: 'auto',
    position: 'relative',
  },
  dialogHeader: {
    background: Colors.grey800,
    height: Consts.TITLE_HEIGHT,
    padding: '0px 20px',
  },
  dialogTitle: {
    color: Colors.white,
    fontSize: 24,
    lineHeight: '45px',
    zIndex: 2,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
  },
  mainButton: {
    marginRight: 12.5,
    minWidth: 140
  },
  zoomButton: {
    fontSize: 30,
    color: Colors.grey800
  },
  link: {
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: 1,
  },
  arrow: {
    fontSize: '125%',
    paddingRight: 10,
  },
  camera51Actions: {
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
    position: 'relative',
    height: '100%',
    margin: 30,
  },
};
